import React, { useState } from "react";
import { MultiSelect } from "react-multi-select-component";

import {
  Box
} from '@chakra-ui/react';

const options = [
  { label: "Sem anúncio", value: "0" },
  { label: "Mercado Livre", value: "1" },
  { label: "Magalu", value: "2"},
  { label: "Amazon", value: "3"}
];


const nameStrings = {
    "allItemsAreSelected": "Todos Selecionados",
    "clearSearch": "Limpar pesquisa",
    "clearSelected": "Clear Selected",
    "noOptions": "Sem opções",
    "search": "Pesquisar",
    "selectAll": "Selecionar todos",
    "selectAllFiltered": "Selecionar todos",
    "selectSomeItems": "Selecione",
    "create": "Create",
}


const MultipleSelectMktplaces = ({selectedOptionsStatus, handleSelectedOptionsStatusChange}) => {
  return (
    <Box style={{ position: 'relative', zIndex: 10 }}>
      <MultiSelect
        id="MultipleSelectMktplaces"
        options={options}
        value={selectedOptionsStatus}
        onChange={handleSelectedOptionsStatusChange}
        labelledBy="Selecione..."
        disableSearch
        overrideStrings={nameStrings}
      />
    </Box>
  );
};

export default MultipleSelectMktplaces;
